module.exports = __webpack_public_path__ + "img/building_jiagou_1080.13731e96.png";